/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HabitPagedResult } from '../../models/habit-paged-result';

export interface GetHabit$Json$Params {

/**
 * Format - int32.
 */
  page?: number;

/**
 * Format - int32.
 */
  pageSize?: number;
  'api-version'?: string;
}

export function getHabit$Json(http: HttpClient, rootUrl: string, params?: GetHabit$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<HabitPagedResult>> {
  const rb = new RequestBuilder(rootUrl, getHabit$Json.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HabitPagedResult>;
    })
  );
}

getHabit$Json.PATH = '/habit';
